import { ApproveRejectAppointmentModal, EditWidgetVehicleDetail, WidgetAppointmentRequestModel } from './../business-entities/widget-appointment-request-model';
import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { DataService } from 'projects/Autofacets-Core/src/app/services/data.service';
import { Urls } from 'projects/Autofacets-Core/src/app/utils/urls';
import { DFModel } from '../business-entities/df-model';

@Injectable({
  providedIn: 'root',
})
export class WidgetDataService {
  constructor(private dataProvider: DataService) {}

  async getWidgetAppointmentList(
    requestModel: WidgetAppointmentRequestModel
  ): Promise<GenericResponse<any>> {
    return this.dataProvider
      .Post<GenericResponse<any>>(
        Urls.GetWidgetAppointmentRequest,
        requestModel
      )
      .toPromise();
  }

  async GetWidgetAppointmentDetail(Id: number,languageCode:string): Promise<GenericResponse<any>> {
    return this.dataProvider
      .Get<GenericResponse<any>>(Urls.GetWidgetAppointmentDetail, Id,languageCode)
      .toPromise();
  }

  DeleteAppointment(id: any): Promise<any> {
    return this.dataProvider
      .Delete<GenericResponse<any>>(Urls.DeleteWidgetAppointment, id)
      .toPromise();
  }

  async ApproveRejectWidgetAppointment(approverejectModal: ApproveRejectAppointmentModal): Promise<GenericResponse<any>> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.ApproveRejectWidgetAppointment, approverejectModal).toPromise();
  }
  async AddDFDetails(model: DFModel): Promise<any> {
    return this.dataProvider.Post<any>(Urls.AddDFDetails, model).toPromise();
  }
  async getAppointmentStatusList(): Promise<any> {
    return this.dataProvider.Get<any>(Urls.getAppointmentStatusList).toPromise();
  }

  async updateWidgetAppointmentVehicleDetail(model:EditWidgetVehicleDetail)
  {
    return this.dataProvider.Put<any>(Urls.UpdateWidgetAppointmentVehicleDetail,model).toPromise(); 
  }
}
